// extracted by mini-css-extract-plugin
module.exports = {"list":"Mnemonics_list__2MErq","warning":"Mnemonics_warning__1fvNo"};